import { Directive } from '@angular/core'

import { ThemeComponent } from '@flowx/core-theme'

import { FlxComponentThemeBaseDirective } from './component-theme-base.directive'

import { ComponentType } from '../injectors'

@Directive({
  selector: '[flxSegmentedOption], flx-segmented-option',
  standalone: true,
  hostDirectives: [FlxComponentThemeBaseDirective],
  providers: [{ provide: ComponentType, useValue: ThemeComponent.SegmentedButton }],
})
export class FlxSegmentedBtnThemeDirective {}
